var map = {
	"./title-carousel.de-CH.json": 1124,
	"./title-carousel.de-DE.json": 1125,
	"./title-carousel.en-CA.json": 1126,
	"./title-carousel.en-GB.json": 1127,
	"./title-carousel.en-IN.json": 1128,
	"./title-carousel.en-ME.json": 1129,
	"./title-carousel.en-US.json": 1130,
	"./title-carousel.es-EM.json": 1131,
	"./title-carousel.es-ES.json": 1132,
	"./title-carousel.fr-BE.json": 1133,
	"./title-carousel.fr-CA.json": 1134,
	"./title-carousel.fr-CH.json": 1135,
	"./title-carousel.nl-BE.json": 1136,
	"./title-carousel.nl-NL.json": 1137,
	"./title-carousel.pl-PL.json": 1138,
	"./title-carousel.pt-BR.json": 1139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1123;